<template>
  <PageFiles
    :files="files"/>
</template>

<script>
import Component from '~/sites/shop/pages/files/index'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/manualy-ke-stazeni',
      de: '/dateien',
      en: '/files',
      sk: '/manualy-k-stiahnutiu',
    },
  },
  async asyncData({ app, store, query, redirect, req, res }) {
    if (process.server) {
      res.set('X-Inspishop-Cache-Control', `public, max-age=${app.$env.STATELESS_TTL}`)
    }

    // Handle duplicates
    if (query.p === '0') {
      delete query.p
      redirect(301, req.path, query)
      return
    }

    return {
      files: await store.dispatch('file/LOAD_FILES'),
    }
  },
}
</script>
